/* eslint-disable */
import { SeamHealth } from 'app/model';
import { Mcc } from 'app/model/cris/mcc';
import { HealthData } from 'app/model/tools/health-data';
import { RootState } from 'app/store';

import { SliceState } from './slice-state';

const toSliceState = (state: RootState): SliceState => state.tools;

export const selectHealthData = (state: RootState): HealthData[] | undefined => toSliceState(state).healthData;

export const selectSeamHealth = (state: RootState): SeamHealth[] | undefined => toSliceState(state).seamHealth;

export const selectLatestDataDate = (state: RootState): string => {
    let min = '';

    for (const status of toSliceState(state).seamHealth ?? []) {
        if ('' === min) {
            min = status.latestFileDate;
            continue;
        }

        if (status.latestFileDate < min) {
            min = status.latestFileDate;
        }
    }

    return min;
};

export const selectMccLookupShown = (state: RootState): boolean => toSliceState(state).mccLookupShown;

export const selectMccLookupData = (state: RootState): Mcc[] | undefined => toSliceState(state).mccLookupData;
